import type { FC, ReactNode } from "react";

import DarkButton from "./DarkButton";
import GoldButton from "./GoldButton";
import MonogramButton from "./MonogramButton";
import type { RegularButtonProps } from "./RegularButton";
import RegularButton from "./RegularButton";
import SimpleButton from "./SimpleButton";

export enum ButtonTypes {
	REGULAR = "REGULAR",
	FILL = "FILL",
	GOLD_BORD_FILL = "GOLD_BORD_FILL",
	MONOGRAM = "MONOGRAM",
	GOLD = "GOLD",
	DARK = "DARK",
	SIMPLE = "SIMPLE"
}

export enum ButtonSizes {
	XS = "XS",
	SM = "SM",
	MD = "MD",
	XL = "XL",
	XXL = "XXL"
}

export interface BaseButtonProps {
	className?: string;
	children?: string | ReactNode;
	onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	type?: "submit" | "button" | "input";
	loading?: boolean;
	disabled?: boolean;
	readonly?: boolean;
	startIcon?: ReactNode;
	endIcon?: ReactNode;
	size?: ButtonSizes;
}

export interface ButtonProps extends RegularButtonProps {
	variant?: ButtonTypes;
}

const Button: FC<ButtonProps> = ({
	type = "button",
	variant = ButtonTypes.REGULAR,
	children,
	size = ButtonSizes.MD,
	...rest
}) => {
	if (variant === ButtonTypes.MONOGRAM) {
		return (
			<MonogramButton type={type as "submit" | "button"} size={size} {...rest}>
				{children}
			</MonogramButton>
		);
	}

	if (variant === ButtonTypes.GOLD) {
		return (
			<GoldButton type={type as "submit" | "button"} size={size} {...rest}>
				{children}
			</GoldButton>
		);
	}

	if (variant === ButtonTypes.SIMPLE) {
		return (
			<SimpleButton type={type as "submit" | "button"} size={size} {...rest}>
				{children}
			</SimpleButton>
		);
	}

	if (variant === ButtonTypes.DARK) {
		return (
			<DarkButton type={type as "submit" | "button"} size={size} {...rest}>
				{children}
			</DarkButton>
		);
	}

	return (
		<RegularButton type={type} variant={variant} size={size} {...rest}>
			{children}
		</RegularButton>
	);
};

export default Button;
